import React from 'react';
import { withTranslation } from 'react-i18next';
import './Reporting.css';

function ReportingView({ t, deviceStatus }) {
  const isIssueDetected = false;

  return (
    <div className="reporting-view-container">
      <h1>{t("reporting_view.title")}</h1>
      <div className={`status-box ${isIssueDetected ? 'status-issue' : 'status-normal'}`}>
        <p>
          <b>{t("reporting_view.status")}:</b> {isIssueDetected ? t("reporting_view.abnormal") : t("reporting_view.working_normally")}
        </p>
      </div>
      <div className="content-box">
        <h2>Consumption</h2>
        <p>{t("reporting_view.coming_soon")}</p>
      </div>
      <div className="content-box">
        <h2>{t("reporting_view.contact_us")}</h2>
        <p>{t("reporting_view.email")}</p>
        <p>{t("reporting_view.phone.belgium")}</p>
        <p>{t("reporting_view.phone.france")}</p>
      </div>
    </div>
  );
}

export default withTranslation()(ReportingView);
